import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';

function OutOfStock({ onNotifyMeClick }) {
    return (
        <span className="product-tile__out-of-stock-notification product-tile__notification" onClick={onNotifyMeClick}>
            <span className="product-tile__stock-notification-label">
                <Translation translationKey="product-tile-notification-label-out-of-stock" />
            </span>
            <span className="product-tile__notify-on-restock">
                <Translation translationKey="product-tile-notification-action-out-of-stock" />
            </span>
        </span>
    );
}

OutOfStock.propTypes = {
    onNotifyMeClick: PropTypes.func.isRequired
};

export default OutOfStock;
